module.exports = __webpack_public_path__ + "img/xuanzhongyouxiaright.122ee011.png";